"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UrlHelper = (function () {
    function UrlHelper() {
    }
    UrlHelper.isEmailAdress = function (emailAdress) {
        var regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regExp.test(emailAdress);
    };
    UrlHelper.isUrl = function (url) {
        var regExp = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
        return regExp.test(url);
    };
    return UrlHelper;
}());
exports.UrlHelper = UrlHelper;
//# sourceMappingURL=urlHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/cellProvider/urlHelper.js
// module id = 20
// module chunks = 0